import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as backpackActions from '../actions/backpack-actions.js';
import './BackpackPage.css';

import BackpackGrid from '../components/BackpackGrid.js';

class BackpackPage extends Component {
  componentWillMount() {
    this.props.backpackActions.requestBackpackItems();
  }

  render() {
    const { backpack } = this.props;

    // Filter out any items with `item.data.hideFromBackpack` as true.
    let items = backpack.items.filter((item) => {
      if (item.data && item.data.hideFromBackpack) {
        return false;
      } else {
        return true;
      }
    });

    return (
      <div className="BackpackPage">
        <BackpackGrid items={items} />

        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    backpack: state.backpack
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    backpackActions: bindActionCreators(backpackActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BackpackPage);



// WEBPACK FOOTER //
// ./src/containers/BackpackPage.js